//Library
import React, { Component } from 'react';
//redux
import { connect } from 'react-redux';
import { cleanRedux } from '../../action/anueInfoAction';

class Step3 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            outFundID: undefined, outFundName: undefined, outUnit: undefined, inFundID: undefined, inFundName: undefined,
            rspDay: undefined, rspAmt: undefined, feeRate: undefined, bankCodeDesc: undefined, accNo: undefined,trCcyCodeDesc:undefined
        }
    }

    goSearch() {
        window.location.href ="../../../EC/member/order-check";
    }

    componentWillMount() {
        this.setState({
            outFundID: this.props.TSRDataInfo.outFundID,
            outFundName: this.props.TSRDataInfo.outFundName,
            outUnit: this.props.TSRDataInfo.tsrUnit,
            inFundID: this.props.selectTsrFund.fundID,
            inFundName: this.props.selectTsrFund.shortName,
            rspDay: this.props.TSRDataInfo.rspDay,
            rspAmt: this.props.TSRDataInfo.rspAmt,
            feeRate: this.props.TSRDataInfo.feeRate,
            bankCodeDesc: this.props.TSRDataInfo.bankCodeDesc,
            accNo: this.props.TSRDataInfo.accNo,
            trCcyCodeDesc:this.props.TSRDataInfo.trCcyCodeDesc
        }, () => {
            this.props.cleanRedux();
        })
    }

    render() {
        return <fieldset>
            <div className="featureBox">
                <div className="fundconfirmingblock">
                    <div className="blackTitle hrspace">
                        <span>好日子 - 帳戶庫存</span>
                        <div className="hr"></div>
                    </div>
                    <div>
                        <div className="fundlist">
                            <div className="fundlisttitle">轉出基金名稱</div>
                            <div className="fundnameold">（{this.state.outFundID}）{this.state.outFundName}</div>
                        </div>
                        <div className="fundlist">
                            <div className="fundlisttitle">轉出單位數</div>
                            <div className="fundamount listtextstyle">{this.state.outUnit}</div>
                        </div>
                        <div className="fundlist">
                            <div className="fundlisttitle">轉入基金名稱</div>
                            <div className="fundnamenew">（{this.state.inFundID}）{this.state.inFundName}</div>
                        </div>
                    </div>
                </div>
                <div className="grayhr"></div>
                {
                    this.state.rspDay !== "" ?
                        <div className="fundconfirmingblock">
                            <div className="blackTitle hrspace">
                                <span>好日子 - 定期定額</span>
                                <div className="hr"></div>
                            </div>
                            <div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">終止扣款基金</div>
                                    <div className="fundnameold">（{this.state.outFundID}）{this.state.outFundName}</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">新增扣款基金</div>
                                    <div className="fundnamenew">（{this.state.inFundID}）{this.state.inFundName}</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">扣款日</div>
                                    <div className="funddeductiondate listtextstyle">每月{this.state.rspDay}日</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">扣款金額</div>
                                    <div className="funddeductionsum listtextstyle">{this.state.trCcyCodeDesc}{this.state.rspAmt}元</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">手續費率</div>
                                    <div className="funddeductionrate listtextstyle">{this.state.feeRate}%</div>
                                </div>
                                <div className="fundlist">
                                    <div className="fundlisttitle">扣款帳號</div>
                                    <div className="funddeductionaccount listtextstyle">{this.state.bankCodeDesc} {this.state.accNo}</div>
                                </div>
                            </div>
                        </div> : ""
                }
            </div>
            <div className="btnbackblock btninquire" onClick={() => { this.goSearch() }}>今日委詢查詢/取消</div>
            <div className="attentionblcok">
                <h1>- 注意事項 -</h1>
                <p>若超過本營業日交易時間 13:00，為下一營業日之交易；基金淨值日之計算，依基金公司規定為準，委託交易內容已發至您的電子郵件信箱。請您於扣款日當日 14:00 前，將款項存入您的扣款指定帳號，以避免扣款失敗情形發生，交易確認書於三至五個營業日內寄至您的電子郵件信箱。如有任何問題，歡迎來電鉅亨投顧。</p>
            </div>
        </fieldset>
    }

}
function mapStateToProps(state) {
    return {
        TSRDataInfo: state.anueInfoState.TSRDataInfo,
        selectTsrFund: state.anueInfoState.selectTsrFund,
        selectPDF: state.anueInfoState.selectPDF,
    };
}
export default connect(mapStateToProps, { cleanRedux })(Step3);